/* prettier-ignore */
jQuery(document).ready(function ($) {
    // Hide loading div - You can find #loading-div in index.php or in parts/global/posts-by-category.php
    //objectFitPolyfill($('img')); 
    //console.log("objectFitPolyfill", objectFitPolyfill)
    $("#loading").hide();
    $('input[name="tapahtumat_daterange"]').daterangepicker({minDate:new Date(), 
      locale:
        { format: "DD.MM.YYYY", 
          cancelLabel: 'Clear',
        }, 
      autoUpdateInput: false, autoApply:true});    

    $('input[name="tapahtumat_daterange"]').on('apply.daterangepicker', function(ev, picker) {
      var startDate = picker.startDate.format("DD.MM.YYYY");
      var endDate = picker.endDate.format("DD.MM.YYYY");
      filter(new Date(picker.startDate).getTime()/1000, new Date(picker.endDate).getTime()/1000);
      $(this).val(startDate + " - " + endDate);
    });

    $('input[name="tapahtumat_daterange"]').on('cancel.daterangepicker', function(ev, picker) {
      $(this).val("");
      $("article.product").removeClass("hidden");
      //search({post_type:"product", category: $(".js-filter-item.active a").data("category")});
    });
    // Filtering posts by links - You can find this in index.php    
    $(document).on('click', '.js-filter-item .js-filter-item-link', function(e) {
      e.preventDefault();  
          
      // Get category when clicked link  
      var category = $(this).data('category');    

      // Get post_type, post_type can be post or product, default is post
      var post_type = $(this).closest('[data-post_type]').data("post_type") || "post";
      // TODO: Show pagination when posts are over 9
      // TODO: Add tag filtering to this script to use in category pages
 
      // Ajax  
      search({category:category, post_type: post_type});
    });

    function inBetween(n1, r1, r2) {
      return n1 > r1 && n1 < r2;
    }

    function filter(start, end) {
      
      $("article.product").addClass("hidden").each(function() {

        if ($(this).data("event_start") === "" && $(this).data("event_end") === "") {
          $(this).removeClass("hidden");
        } else {
          var event_start = Number($(this).data("event_start"));
          var event_end = Number($(this).data("event_end")); 
          if (inBetween(event_start, start, end) || inBetween(event_end, start, end) ) {
            $(this).removeClass("hidden");
          }
          
        }
        
      });
    }
    function search(data, page, onPage) {
      data.action = "eerikkila_filter";
      data.page = page === undefined ? 1 : page;
      data.onPage = onPage === undefined ? -1 : onPage;
      data.lang = jQuery('html')[0].getAttribute('lang'); // pakkosyötetään nykyinen kieli palvelimelle
      
      $.ajax({
        url: wpAjax.ajaxUrl, // Get ajax 
        data: data, 
        type: 'post',
        beforeSend: function () {
          // Show loading div when loading posts with animation
          $("#loading").show();
          // use CSS animation instead of jquery.animate
          $('.filtered-posts').animate({'opacity':'0.5'}, 300); // Filtered-posts are used in index.php and filter.php
        },
        complete: function () {
          // Hide loading div when found posts
          $("#loading").hide();
        },
        success: function (result) {
          // Show results with animation 
          $('.filtered-posts').html(result);

          // use CSS animation instead of jquery.animate
          $('.filtered-posts').animate({ 'opacity': '1.0' }, 300);
        },
        error: function (result) {
          // Show warning in consolelog
          console.warn(result);
        }
      });
    }

    // Add active class when clicked link
    $('.js-filter-item').click(function(e) {
      e.preventDefault();
      $('.js-filter-item').removeClass('active');
      $(this).addClass('active');
    });
});
